import React from 'react';

import {FloatingMenuItem} from '@pb/kit-component-menu';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './listbox.component.module.styl';

import type {FloatingMenuItemProps} from '@pb/kit-component-menu';


const classNames = withCssModule(styles);

export type ListBoxItemProps = FloatingMenuItemProps;


/**
 * Selectable row inside a `<Listbox>`. Thin wrapper around `FloatingMenuItem`
 * that adds listbox-specific CSS and sets `tabIndex="-1"` so focus is managed
 * virtually by `useListbox`.
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/utils-listbox--documentation}
 */
export function ListBoxItem(props: ListBoxItemProps) {
    const {
        ref,
        className,
        ...restProps
    } = props;

    return (
        <FloatingMenuItem
            ref={ref}
            tabIndex={-1} // for virtual focus management
            {...restProps}
            className={classNames('list-box-item', className)}
        />
    );
}
